<template>
  <div>
    <div style="display: flex; align-items: center;">
      <b-icon
        class="has-text-aquamarine"
        style="margin-right: 10px;"
        pack="fa"
        icon="filter"
      ></b-icon>
      <b-field
        v-for="f in filter[resourceType].filters.filter(f => f.hidden !== true)"
        :key="f.value"
        style="margin-bottom: 0px; margin-right: 10px;"
      >
        <b-input
          v-if="f.type === 'input'"
          v-model="filter[resourceType].filter[f.value]"
          :placeholder="$gettext(f.label)"
          :style="f.style"
          :icon="f.icon"
          @input="onFilter"
        ></b-input>
        <b-select
          v-if="f.type === 'select'"
          v-model="filter[resourceType].filter[f.value]"
          @input="onFilter"
          :placeholder="$gettext(f.label)"
        >
          <!-- no selection -->
          <option
            :value='null'
            class="is-italic"
          >
            <translate>Public.select.reset</translate>
          </option>
          <!-- filters on research activity from store -->
          <option
            v-for="filterOption in f.options"
            :key="filterOption"
            :value="filterOption">
              <translate>
                {{`Public.filter.${f.value}.${filterOption.toLowerCase()}`}}
              </translate>
          </option>
        </b-select>
      </b-field>
    </div>

    <div v-if="resourceType === 'forschungsprojekt'" style="margin-top: 10px; margin-left: 34px; display: flex; align-items: center;">
      <b-field
        style="margin-bottom: 0px; margin-right: 10px;"
      >
        <b-select
          v-model="filter[resourceType].filter.sdg"
          icon="bullseye"
          :placeholder="$gettext('Sdg.Placeholder')"
          @input="onFilter"
        >
          <option :value="null">
            <translate>Sdg.NoSelection</translate>
          </option>
          <option value="ANY"><translate>Sdg.Any</translate></option>
          <optgroup :label="$gettext('Sdg.Category')">
            <option value="BIOSPHERE"><translate>Sdg.Biosphere</translate></option>
            <option value="SOCIETY"><translate>Sdg.Society</translate></option>
            <option value="ECONOMY"><translate>Sdg.Economy</translate></option>
          </optgroup>
          <optgroup :label="$gettext('Sdg.SingleSelection')">
            <option value="SDG1"><translate>Sdg.SDG1</translate></option>
            <option value="SDG2"><translate>Sdg.SDG2</translate></option>
            <option value="SDG3"><translate>Sdg.SDG3</translate></option>
            <option value="SDG4"><translate>Sdg.SDG4</translate></option>
            <option value="SDG5"><translate>Sdg.SDG5</translate></option>
            <option value="SDG6"><translate>Sdg.SDG6</translate></option>
            <option value="SDG7"><translate>Sdg.SDG7</translate></option>
            <option value="SDG8"><translate>Sdg.SDG8</translate></option>
            <option value="SDG9"><translate>Sdg.SDG9</translate></option>
            <option value="SDG10"><translate>Sdg.SDG10</translate></option>
            <option value="SDG11"><translate>Sdg.SDG11</translate></option>
            <option value="SDG12"><translate>Sdg.SDG12</translate></option>
            <option value="SDG13"><translate>Sdg.SDG13</translate></option>
            <option value="SDG14"><translate>Sdg.SDG14</translate></option>
            <option value="SDG15"><translate>Sdg.SDG15</translate></option>
            <option value="SDG16"><translate>Sdg.SDG16</translate></option>
            <option value="SDG17"><translate>Sdg.SDG17</translate></option>
          </optgroup>
        </b-select>
      </b-field>
    </div>

    <div v-if="resourceType === 'publikation'" style="margin-top: 10px; margin-left: 34px; display: flex; align-items: center;">
      <b-field
        style="padding-top: 5px; margin-bottom: 0px; margin-right: 10px;"
      >
        <b-checkbox
          v-model="filter[resourceType].filter.inProject"
          @input="onFilter"
        >
          <translate>Public.filter.inProject</translate><translate v-if="inProject">Public.filter.fundedBy</translate>
        </b-checkbox>
      </b-field>
      <b-field
        style="margin-bottom: 0px; margin-right: 10px;"
      >
        <b-select
          v-model="filter[resourceType].filter.fundedByCategory"
          v-bind:class="{ hiddenField: !inProject }"
          icon="credit-card"
          :placeholder="$gettext('Public.filter.beliebigerMittelgeber')"
          @input="onFilter"
        >
          <option :value="null">
            <translate>Public.filter.beliebigerMittelgeber</translate>
          </option>
          <option value="DFG"><translate>Public.filter.funded_by.DFG</translate></option>
          <option value="EU"><translate>Public.filter.funded_by.EU</translate></option>
          <option value="BMBF"><translate>Public.filter.funded_by.BMBF</translate></option>
          <option value="ANDERE_BM"><translate>Public.filter.funded_by.ANDERE_BM</translate></option>
          <option value="SMWK"><translate>Public.filter.funded_by.SMWK</translate></option>
          <option value="ANDERE_SAECHSISCHE_MINISTERIEN"><translate>Public.filter.funded_by.ANDERE_SAECHSISCHE_MINISTERIEN</translate></option>
          <option value="DAAD"><translate>Public.filter.funded_by.DAAD</translate></option>
          <option value="UNI_LE"><translate>Public.filter.funded_by.UNI_LE</translate></option>
          <option value="WIRTSCHAFT"><translate>Public.filter.funded_by.WIRTSCHAFT</translate></option>
          <option value="STIFTUNGEN_DE"><translate>Public.filter.funded_by.STIFTUNGEN_DE</translate></option>
          <option value="ANDERE"><translate>Public.filter.funded_by.ANDERE</translate></option>
        </b-select>
      </b-field>
    </div>

    <div v-if="resourceType === 'preis' && userIsLoggedIn" style="margin-top: 10px; margin-left: 34px; display: flex; align-items: center;">
      <b-field
        style="margin-bottom: 0px; margin-right: 10px;"
      >
        <b-select
          v-model="filter[resourceType].filter.typeIds"
          icon="graduation-cap"
          :placeholder="$gettext('Public.filter.beliebigerPreis')"
          @input="onFilter"
        >
          <option :value="null">
            <translate>Public.filter.beliebigerPreis</translate>
          </option>
          <option value="PREIS_3"><translate>Public.filter.typeIds.preis_3</translate></option>
          <option value="PREIS_29"><translate>Public.filter.typeIds.preis_29</translate></option>
          <option value="PREIS_30"><translate>Public.filter.typeIds.preis_30</translate></option>
          <option value="PREIS_31"><translate>Public.filter.typeIds.preis_31</translate></option>
          <option value="PREIS_32"><translate>Public.filter.typeIds.preis_32</translate></option>
          <option value="PREIS_2"><translate>Public.filter.typeIds.preis_2</translate></option>
          <option value="PREIS_33"><translate>Public.filter.typeIds.preis_33</translate></option>
          <option value="PREIS_4"><translate>Public.filter.typeIds.preis_4</translate></option>
          <option value="PREIS_34"><translate>Public.filter.typeIds.preis_34</translate></option>
          <option value="PREIS_35"><translate>Public.filter.typeIds.preis_35</translate></option>
          <option value="PREIS_36"><translate>Public.filter.typeIds.preis_36</translate></option>
          <option value="PREIS_37"><translate>Public.filter.typeIds.preis_37</translate></option>
          <option value="WEITERE_PREISE"><translate>Public.filter.typeIds.weiterePreise</translate></option>
        </b-select>
      </b-field>
    </div>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'
import debounce from 'debounce'
import PublicViewHelper from '@/components/mixins/PublicViewHelper'

export default {
  name: 'fob-public-list-filter',
  props: ['resourceType'],
  mixins: [PublicViewHelper],
  computed: {
    ...mapGetters({
      userIsLoggedIn: 'user/isAuthorized',
      filter: 'publicView/getFilter'
    }),
    userIsAdmin () {
      return this.userIsLoggedIn && this.$store.getters['user/roles'].ADMIN === true
    },
    inProject () {
      if (this.resourceType === 'publikation') {
        return this.filter[this.resourceType].filter.inProject
      } else {
        return false
      }
    }
  },
  methods: {
    onFilter: debounce(function () {
      this.setFirstPage()
      this.loadAsyncData()
    }, 500)
  }
}

</script>

<style lang="scss">
  .hiddenField {
    opacity: 0;
    // transition: opacity 0.3s
  }
</style>



// WEBPACK FOOTER //
// src/components/public/PublicListFilter.vue